/* eslint-disable @typescript-eslint/no-unused-vars */
import { UtilityService } from '@app/services/utility.service';

export const showTabsFor = (params: {
    utilityService: UtilityService;
}): any => {};
